import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { selectTilesLoading } from '../../../redux/features/firestore/tiles/slice';
import { selectCellsLoading } from '../../../redux/features/firestore/cells/slice';
import { APP_BANNER_DISMISSED_EVENT } from '../../AppBanner';
import { t } from '../../../i18n';
import './TilesLoadingIndicator.scss';

const BANNER_DISMISSED_KEY = 'app-banner-dismissed';

const TilesLoadingIndicator = () => {
    const isTilesLoading = useAppSelector(selectTilesLoading);
    const isCellsLoading = useAppSelector(selectCellsLoading);
    const isLoading = isTilesLoading || isCellsLoading;
    const label = isCellsLoading && !isTilesLoading ? t('web.map.loadingTerritory') : t('web.map.loadingTiles');

    const [bannerVisible, setBannerVisible] = useState(
        () => sessionStorage.getItem(BANNER_DISMISSED_KEY) !== '1'
    );

    useEffect(() => {
        const handler = () => setBannerVisible(false);
        window.addEventListener(APP_BANNER_DISMISSED_EVENT, handler);
        return () => window.removeEventListener(APP_BANNER_DISMISSED_EVENT, handler);
    }, []);

    if (!isLoading) return null;

    return (
        <div className={`tiles-loading${bannerVisible ? '' : ' tiles-loading--no-banner'}`}>
            <div className="tiles-loading__spinner" />
            <span>{label}</span>
        </div>
    );
};

export default TilesLoadingIndicator;
